import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { Link, useHistory } from "react-router-dom";
import _ from "lodash";
import ReactPaginate from "react-paginate";

function ManMasterIntentList(props) {
  const [IntentList, setIntentList] = useState([]);
  const [IntentList2, setIntentList2] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [paginatedPosts, setpaginatedPosts] = useState();
  const [Record, seRecord] = useState([]);

  const navigate = useHistory();
  let pageSize = 10;
  // const history=useHistory();
  const mangerId = localStorage.getItem("ManegerId");

  useEffect(() => {
    LoadIntents();
  }, [pageSize]);

  const LoadIntents = () => {
    const datavalue = {
      MangId: mangerId,
    };

    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/GetAllMasterIntentByManagerId`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions).then((res) => {
      //console.log("list", res.data)
      seRecord(res.data.length);
      if (res.data.length > 10) {
        setIntentList(res.data);

        setpaginatedPosts(_(res.data).slice(0).take(pageSize).value());
      } else {
        setIntentList2(res.data);
      }
    });
    localStorage.removeItem("PortalStatus");
  };
  const pageCount = IntentList ? Math.ceil(IntentList.length / pageSize) : 0;
  if (pageCount === 1) return null;
  const pages = _.range(1, pageCount + 1);

  const handlePageClick = async (data) => {
    let currentPage = data.selected + 1;
    setCurrentPage(currentPage);
    const startIndex = (currentPage - 1) * pageSize;
    const paginatedPost = _(IntentList)
      .slice(startIndex)
      .take(pageSize)
      .value();
    setpaginatedPosts(paginatedPost);
  };

  const EditIntents = (valid) => {
    localStorage.setItem("IntentInfo", valid);

    //console.log("the vaue", valid)
  };
  const deleteIntent = (value) => {
    //console.log("the vaue", value)

    const datavalue = {
      id: value,
    };
    var authOptions = {
      method: "post",
      url: `${process.env.REACT_APP_API_URL}/DeleteIntents`,
      data: datavalue,
      headers: { "Content-Type": "multipart/form-data" },
    };
    axios(authOptions)
      .then((res) => {
        //console.log("get value", res);
        //console.log("success")
        Swal.fire({
          title: "Success",
          text: "Deleted successfully",
          icon: "success",
          confirmButtonText: "Ok",
        }).then(function () {
          window.location.reload(true);
        });
      })
      .catch((error) => {
        //console.log("error occur", error);
      });
  };
  const BackFunc = () => {
    navigate.push("/index");
  };
  return (
    <>
      <div className="page-content-wrapper">
        <div className="page-content">
          <div className="page-bar">
            <div className="page-title-breadcrumb">
              <div className=" pull-left">
                <div className="page-title">List of Intents</div>
              </div>
              <div className=" pull-right">
                <button
                  type="submit"
                  className="btn btn-primary d-inline-block"
                  onClick={BackFunc}
                >
                  {" "}
                  <i className="fa fa-arrow-left" aria-hidden="true"></i>
                </button>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-12">
                  <div className="card">
                    {/* <div className="card-head">
                                            <header>Intents List</header>
                                            <div className="tools">
                                               
                                            </div>
                                        </div> */}
                    <div className="card-body ">
                      <div className="table-responsive">
                        <table className="table table-striped custom-table table-hover">
                          <thead>
                            <tr>
                              <th>Intents</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {Record > 10
                              ? paginatedPosts &&
                                paginatedPosts.length > 0 &&
                                paginatedPosts.map((item) => (
                                  <tr>
                                    <td>
                                      <a href="#">{item.intents}</a>
                                    </td>
                                    <td>
                                      <Link
                                        to="/Update_MasterIntent"
                                        onClick={() => EditIntents(item.id)}
                                        className="btn btn-primary btn-xs py-2"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </Link>

                                      <button
                                        className="btn btn-danger btn-xs py-2"
                                        onClick={() => deleteIntent(item.id)}
                                      >
                                        <i className="fa fa-trash-o "></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))
                              : IntentList2 &&
                                IntentList2.length > 0 &&
                                IntentList2.map((item) => (
                                  <tr>
                                    <td>
                                      <a href="#">{item.intents}</a>
                                    </td>
                                    <td>
                                      <Link
                                        to="/Update_MasterIntent"
                                        onClick={() => EditIntents(item.id)}
                                        className="btn btn-primary btn-xs py-2"
                                      >
                                        <i className="fa fa-pencil"></i>
                                      </Link>

                                      <button
                                        className="btn btn-danger btn-xs py-2"
                                        onClick={() => deleteIntent(item.id)}
                                      >
                                        <i className="fa fa-trash-o "></i>
                                      </button>
                                    </td>
                                  </tr>
                                ))}
                          </tbody>
                        </table>
                      </div>
                      {Record > 10 ? (
                        <ReactPaginate
                          previousLabel={"Prev"}
                          nextLabel={"Next"}
                          breakLabel={"..."}
                          pageCount={pageCount}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={3}
                          onPageChange={handlePageClick}
                          containerClassName={
                            "pagination justify-content-center"
                          }
                          pageClassName={"page-item"}
                          pageLinkClassName={"page-link"}
                          activeClassName={"active"}
                          previousClassName={"page-item"}
                          nextClassName={"page-item"}
                          previousLinkClassName={"page-link"}
                          nextLinkClassName={"page-link"}
                        />
                      ) : (
                        <div></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ManMasterIntentList;
